module.exports = __webpack_public_path__ + "res/12-img_game_vs.861d353c2872775ad55f0a17f0ea1ff9.png";